import access from "./assets/ACCESS-ICON.png";
import border from "./assets/CROSS-BORDER-PAYMENT.png";
import transparency from "./assets/TRANSPARENCY-ICON.png";
import security from "./assets/SECURITY-ICON.png";


export const benefitsCardData = [
  {
    image: `${border}`,
    text: "low cost cross-border payment ",
  },
  {
    image: `${transparency}`,
    text: " Transparent Transactions  ",
  },
  {
    image: `${security}`,
    text: "Secure Transactions ",
  },
  {
    image: `${access}`,
    text: "Access to participate in the CASSAVA protocol ",
  },
];
